'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMessageToThread = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

var _addMessageToStubbedThread = require('../../stubbed-thread-history/actions/addMessageToStubbedThread');

var _addMessageToConversation = require('../../actions/ConversationsActions/addMessageToConversation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addMessageToThread = exports.addMessageToThread = function addMessageToThread(_ref) {
  var channel = _ref.channel,
      message = _ref.message;
  return function (dispatch) {
    var isStubbedChannel = channel === _stubbedChannel.STUBBED_CHANNEL;
    return isStubbedChannel ? _q2.default.Promise.resolve(dispatch((0, _addMessageToStubbedThread.addMessageToStubbedThread)(message))) : _q2.default.Promise.resolve(dispatch((0, _addMessageToConversation.addMessageToConversation)({ channel: channel, message: message })));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/addMessageToThread.js
// module id = 1074
// module chunks = 2 3